// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light theme redesign for Existing Application page */
.existing-application-page {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa, #e4e9f2, #dfe6f0);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

/* Orbital background elements */
.orbital-background {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.orbital {
  position: absolute;
  border-radius: 50%;
  opacity: 0.2;
  border: 2px solid rgba(71, 118, 230, 0.3);
}

.orbit-1 {
  width: 60vw;
  height: 60vw;
  top: -15vw;
  right: -15vw;
  animation: rotate 80s linear infinite;
}

.orbit-2 {
  width: 40vw;
  height: 40vw;
  bottom: -10vw;
  left: -10vw;
  animation: rotate 60s linear infinite reverse;
}

.orbit-3 {
  width: 80vw;
  height: 50vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 15s ease-in-out infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { 
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.2;
  }
  50% { 
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.3;
  }
}

/* Main card */
.glass-card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  width: 90%;
  max-width: 500px;
  z-index: 10;
  overflow: hidden;
  position: relative;
  transition: transform 0.3s, box-shadow 0.3s;
}

.glass-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

/* Card header */
.card-header {
  background: linear-gradient(90deg, #4776E6, #8E54E9);
  padding: 20px;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.page-title {
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  padding: 0 0 0 40px;
  text-align: center;
}

/* Back button */
.back-button {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: translateY(-50%) scale(1.1);
}

.back-button svg {
  width: 20px;
  height: 20px;
}

/* Card content */
.card-content {
  padding: 30px;
}

/* Form styling */
.tracking-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  color: #454b60;
  font-size: 0.9rem;
  font-weight: 600;
}

.tracking-input {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(71, 118, 230, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  color: #454b60;
  font-size: 1rem;
  outline: none;
  transition: all 0.3s ease;
}

.tracking-input:focus {
  border-color: #4776E6;
  box-shadow: 0 0 0 2px rgba(71, 118, 230, 0.2);
  background: rgba(255, 255, 255, 1);
}

.tracking-input::placeholder {
  color: #a0a8bd;
}

.tracking-error {
  color: #f04747;
  font-size: 0.9rem;
  margin-top: 5px;
}

/* Button container */
.buttons-container {
  display: grid;
  grid-template-columns: 1fr;  /* Single column */
  justify-items: center;       /* Center horizontally */
  gap: 12px;
}

/* Button styling */
.action-button {
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.action-button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.7);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

.action-button:focus:not(:active)::after {
  animation: ripple 0.8s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    transform: scale(30, 30);
    opacity: 0;
  }
}

.submit-button {
  background: linear-gradient(135deg, #4776E6, #8E54E9);
  color: white;
  box-shadow: 0 4px 12px rgba(71, 118, 230, 0.3);
}

.submit-button:hover {
  background: linear-gradient(135deg, #3c66d6, #7e44d9);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(71, 118, 230, 0.4);
}

.track-button {
  background: linear-gradient(135deg, #11998e, #38ef7d);
  color: white;
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
}

.track-button:hover {
  background: linear-gradient(135deg, #0f897e, #32df71);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(17, 153, 142, 0.4);
}

.exam-button {
  background: linear-gradient(135deg, #FF416C, #FF4B2B);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 65, 108, 0.3);
  margin-top: 10px;
}

.exam-button:hover {
  background: linear-gradient(135deg, #f13361, #ff3a16);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 65, 108, 0.4);
}

/* Notification styling */
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  max-width: 350px;
}

.notification {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: slideIn 0.3s forwards;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.notification-message {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.notification-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  animation: progress 3s linear forwards;
}

@keyframes progress {
  from { width: 100%; }
  to { width: 0%; }
}

/* Notification types */
.success-message {
  background: linear-gradient(to right, #43cea2, #185a9d);
  color: white;
}

.success-message .notification-progress {
  background: rgba(255, 255, 255, 0.5);
}

.input-error {
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  color: white;
}

.input-error .notification-progress {
  background: rgba(255, 255, 255, 0.5);
}

.network-error {
  background: linear-gradient(to right, #5c258d, #4389a2);
  color: white;
}

.network-error .notification-progress {
  background: rgba(255, 255, 255, 0.5);
}

/* Footer styling */
.app-footer {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: #454b60;
  font-size: 0.85rem;
  z-index: 5;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .glass-card {
    width: 95%;
    max-width: 100%;
  }
  
  .page-title {
    font-size: 1.2rem;
  }
  
  .card-content {
    padding: 20px;
  }
  
  .buttons-container {
    grid-template-columns: 1fr;
  }
  
  .notification-container {
    left: 10px;
    right: 10px;
    max-width: none;
  }
}

/* Animation for warnings */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.input-error, .network-error {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ExistingApplication/ExistingApplication.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,SAAS;EACT,4DAA4D;EAC5D,iBAAiB;EACjB,8DAA8D;EAC9D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,yCAAyC;IACzC,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,0BAA0B;EAC1B,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,gBAAgB;AAChB;EACE,oDAAoD;EACpD,aAAa;EACb,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,0BAA0B,GAAG,kBAAkB;EAC/C,qBAAqB,QAAQ,wBAAwB;EACrD,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,UAAU;EACV,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,OAAO,WAAW,EAAE;EACpB,KAAK,SAAS,EAAE;AAClB;;AAEA,uBAAuB;AACvB;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,2BAA2B,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;EACE,wDAAwD;AAC1D","sourcesContent":["/* Light theme redesign for Existing Application page */\r\n.existing-application-page {\r\n  margin: 0;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #f5f7fa, #e4e9f2, #dfe6f0);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Orbital background elements */\r\n.orbital-background {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 0;\r\n}\r\n\r\n.orbital {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  opacity: 0.2;\r\n  border: 2px solid rgba(71, 118, 230, 0.3);\r\n}\r\n\r\n.orbit-1 {\r\n  width: 60vw;\r\n  height: 60vw;\r\n  top: -15vw;\r\n  right: -15vw;\r\n  animation: rotate 80s linear infinite;\r\n}\r\n\r\n.orbit-2 {\r\n  width: 40vw;\r\n  height: 40vw;\r\n  bottom: -10vw;\r\n  left: -10vw;\r\n  animation: rotate 60s linear infinite reverse;\r\n}\r\n\r\n.orbit-3 {\r\n  width: 80vw;\r\n  height: 50vw;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  animation: pulse 15s ease-in-out infinite;\r\n}\r\n\r\n@keyframes rotate {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { \r\n    transform: translate(-50%, -50%) scale(1);\r\n    opacity: 0.2;\r\n  }\r\n  50% { \r\n    transform: translate(-50%, -50%) scale(1.1);\r\n    opacity: 0.3;\r\n  }\r\n}\r\n\r\n/* Main card */\r\n.glass-card {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(8px);\r\n  border: 1px solid rgba(255, 255, 255, 0.8);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  z-index: 10;\r\n  overflow: hidden;\r\n  position: relative;\r\n  transition: transform 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.glass-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Card header */\r\n.card-header {\r\n  background: linear-gradient(90deg, #4776E6, #8E54E9);\r\n  padding: 20px;\r\n  position: relative;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.page-title {\r\n  color: white;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  padding: 0 0 0 40px;\r\n  text-align: center;\r\n}\r\n\r\n/* Back button */\r\n.back-button {\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: none;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  color: white;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.back-button:hover {\r\n  background: rgba(255, 255, 255, 0.35);\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.back-button svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n/* Card content */\r\n.card-content {\r\n  padding: 30px;\r\n}\r\n\r\n/* Form styling */\r\n.tracking-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.input-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.input-group label {\r\n  color: #454b60;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.tracking-input {\r\n  background: rgba(255, 255, 255, 0.8);\r\n  border: 1px solid rgba(71, 118, 230, 0.3);\r\n  border-radius: 8px;\r\n  padding: 12px 16px;\r\n  color: #454b60;\r\n  font-size: 1rem;\r\n  outline: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tracking-input:focus {\r\n  border-color: #4776E6;\r\n  box-shadow: 0 0 0 2px rgba(71, 118, 230, 0.2);\r\n  background: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.tracking-input::placeholder {\r\n  color: #a0a8bd;\r\n}\r\n\r\n.tracking-error {\r\n  color: #f04747;\r\n  font-size: 0.9rem;\r\n  margin-top: 5px;\r\n}\r\n\r\n/* Button container */\r\n.buttons-container {\r\n  display: grid;\r\n  grid-template-columns: 1fr;  /* Single column */\r\n  justify-items: center;       /* Center horizontally */\r\n  gap: 12px;\r\n}\r\n\r\n/* Button styling */\r\n.action-button {\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.action-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 5px;\r\n  height: 5px;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  opacity: 0;\r\n  border-radius: 100%;\r\n  transform: scale(1, 1) translate(-50%);\r\n  transform-origin: 50% 50%;\r\n}\r\n\r\n.action-button:focus:not(:active)::after {\r\n  animation: ripple 0.8s ease-out;\r\n}\r\n\r\n@keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    transform: scale(30, 30);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.submit-button {\r\n  background: linear-gradient(135deg, #4776E6, #8E54E9);\r\n  color: white;\r\n  box-shadow: 0 4px 12px rgba(71, 118, 230, 0.3);\r\n}\r\n\r\n.submit-button:hover {\r\n  background: linear-gradient(135deg, #3c66d6, #7e44d9);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(71, 118, 230, 0.4);\r\n}\r\n\r\n.track-button {\r\n  background: linear-gradient(135deg, #11998e, #38ef7d);\r\n  color: white;\r\n  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);\r\n}\r\n\r\n.track-button:hover {\r\n  background: linear-gradient(135deg, #0f897e, #32df71);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(17, 153, 142, 0.4);\r\n}\r\n\r\n.exam-button {\r\n  background: linear-gradient(135deg, #FF416C, #FF4B2B);\r\n  color: white;\r\n  box-shadow: 0 4px 12px rgba(255, 65, 108, 0.3);\r\n  margin-top: 10px;\r\n}\r\n\r\n.exam-button:hover {\r\n  background: linear-gradient(135deg, #f13361, #ff3a16);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(255, 65, 108, 0.4);\r\n}\r\n\r\n/* Notification styling */\r\n.notification-container {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 1000;\r\n  max-width: 350px;\r\n}\r\n\r\n.notification {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  position: relative;\r\n  animation: slideIn 0.3s forwards;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateX(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.notification-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notification-message {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.notification-progress {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 3px;\r\n  width: 100%;\r\n  animation: progress 3s linear forwards;\r\n}\r\n\r\n@keyframes progress {\r\n  from { width: 100%; }\r\n  to { width: 0%; }\r\n}\r\n\r\n/* Notification types */\r\n.success-message {\r\n  background: linear-gradient(to right, #43cea2, #185a9d);\r\n  color: white;\r\n}\r\n\r\n.success-message .notification-progress {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.input-error {\r\n  background: linear-gradient(to right, #ff7e5f, #feb47b);\r\n  color: white;\r\n}\r\n\r\n.input-error .notification-progress {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.network-error {\r\n  background: linear-gradient(to right, #5c258d, #4389a2);\r\n  color: white;\r\n}\r\n\r\n.network-error .notification-progress {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Footer styling */\r\n.app-footer {\r\n  position: fixed;\r\n  bottom: 10px;\r\n  width: 100%;\r\n  text-align: center;\r\n  color: #454b60;\r\n  font-size: 0.85rem;\r\n  z-index: 5;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 600px) {\r\n  .glass-card {\r\n    width: 95%;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .page-title {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .card-content {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .buttons-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .notification-container {\r\n    left: 10px;\r\n    right: 10px;\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n/* Animation for warnings */\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\r\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\r\n}\r\n\r\n.input-error, .network-error {\r\n  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
